import { render, staticRenderFns } from "./NotificationReadCriticalModal.vue?vue&type=template&id=65b643bf"
import script from "./NotificationReadCriticalModal.vue?vue&type=script&lang=ts"
export * from "./NotificationReadCriticalModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports